module.exports = __webpack_public_path__ + "static/img/cat2.00836510.png";